export default __webpack_public_path__ + "static/media/file.1594d9dd.svg";